import ModalPanel from '@admin/components/modal_panel'
import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Chooser extends React.Component {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    properties: PropTypes.array,
    onChoose: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChoose = this._handleChoose.bind(this)

  render() {
    const { properties } = this.props
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="maha-contactproperty-options">
          { properties.reduce((groups, group, groupIndex) => [
            ...groups,
            <div className="maha-criterion-type" key={`type_${groupIndex}`}>
              <T text={ group.label } />
            </div>,
            ...group.fields.map((property, propertyIndex) => (
              <Button { ...this._getProperty(property) } key={`type_${groupIndex}_property_${propertyIndex}`} />
            ))
          ], []) }
        </div>
      </ModalPanel>
    )
  }

  _getPanel() {
    return {
      title: 't(Choose Property)',
      leftItems: [
        { svg: 'chevron_left', handler: this._handleCancel }
      ]
    }
  }

  _getProperty(property) {
    return {
      label: property.label,
      className: 'maha-criterion-item',
      handler: this._handleChoose.bind(this, property)
    }
  }

  _handleCancel() {
    this.context.form.pop()
  }

  _handleChoose(property) {
    this.props.onChoose(property)
    this.context.form.pop()
  }

}

export default Chooser
